import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './WordPressContentPage.css';

const WordPressContentPage = () => {
  const pageData = window.aquifyConfig?.currentPage;

  if (!pageData) {
    return null; // The router handles the fallback if this is empty, but just in case
  }

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Header />
      <main className="flex-grow py-12 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="bg-white rounded-xl shadow-sm p-6 md:p-12 border border-slate-100">
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8 pb-4 border-b border-slate-100">
              {pageData.title}
            </h1>
            <div 
              className="wordpress-content legal-content"
              dangerouslySetInnerHTML={{ __html: pageData.content }}
            />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default WordPressContentPage;
